export const GET_POSTS = 'GET_POSTS';
export const GET_SLOTS = 'GET_SLOTS';
export const GET_SLOT = 'GET_SLOT';
export const SAVE_SLOT = 'SAVE_SLOT';
